enum ReportStatus {
  Draft = "Draft",
  Unsent = "Unsent",
  Sent = "Sent",
}

export default ReportStatus;